import React, { Fragment, useEffect, useMemo, useState } from 'react'
import CommonFilter from '../../../customControl/CommonFilter'
import CustomTable from '../../../customControl/CustomTable'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllData, verifytoken } from '../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../_actions/loader.actions';
import { ClearLocalStorage } from '../../../components/commonClass/Session';
import { getuserprofileimagebyid } from '../../../components/commonClass/CommonFunctions';
import StatusActionModal from '../../../customControl/StatusActionModal';
import { AgentStatus } from '../../../_constants/agent.constant';
import { agentActions } from '../../../_actions/agent.action';

const CorporateList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [datalist, setDataList] = useState<any>([]);
    const [filterlist, setFilterList] = useState<any>([]);
    const [searchby, setSerachBy] = useState('All');
    const [searchvalue, setSearchValue] = useState('');

    const [modalConfig, setModalConfig] = useState({
        show: false,
        actionType: 'View' as 'Approve' | 'Reject' | 'View',
        viewData: { Remark: '', RejectionReason: '' },
        CorporateAgentId: 0
    });

    const tbaData = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const { data: agentData } = useSelector((store: any) => store.agentOptions);

    const actionOptions = useMemo(() => {
        return (agentData?.statusOptions || []).filter((opt: any) =>
            !([AgentStatus.Pending, AgentStatus.Submit, AgentStatus.ReSubmit] as number[]).includes(Number(opt.StatusId))
        );
    }, [agentData?.statusOptions]);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [loginUserDomainMasterId, setLoginUserDomainMasterId] = useState(0); // 1 - Internal, 2 - TA (Travel Agent), 3 - Corporate 

    const getLoginUserDomianId = async () => {
        const userById = await getuserprofileimagebyid();
        if (userById?.status) {
            setLoginUserDomainMasterId(userById?.data?.[0]?.DomainMasterId)
        }
    }

    const getlistdata = async () => {
        localStorage.removeItem("coid");
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            dispatch(loaderActions.start());
            const listdata = await getAllData('/midoffice/v1/getallcorporatelist');
            if (listdata?.status && Array.isArray(listdata?.data)) {
                listdata.data.map((obj: any, index: number) => {
                    obj.SrNo = index + 1;
                    return obj;
                })
                setDataList(listdata.data);
                setFilterList(listdata.data)
                dispatch(loaderActions.end());
            }
            else {
                setDataList([]);
                setFilterList([]);
                dispatch(loaderActions.end());
            }
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const columns: any = [
        {
            name: 'Sr. No.',
            sortable: true,
            float: "left",
            minWidth: "80px",
            maxWidth: "85px",
            isSearch: false,
            isExport: false,
            selector: (listData: any) => listData?.SrNo,
            omit: false
        },
        {
            name: 'Corporate ID',
            key: 'CorporateCode',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.CorporateCode,
        },
        {
            name: 'Company Name',
            key: 'NameOfCompany',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.NameOfCompany,
        },
        {
            name: 'Email ID',
            key: 'EmailId',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.EmailId,
        },
        {
            name: 'Phone No.',
            key: 'PhoneNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.PhoneNo,
        },
        {
            name: 'Sales Manager',
            key: 'SalesManagerName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.SalesManagerName,
        },
        {
            name: 'KAM Manager',
            key: 'KAMManagerName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.KAMManagerName,
        },
        {
            name: 'Region',
            key: 'RegionName',
            sortable: true,
            float: "left",
            minWidth: "85px",
            maxWidth: "90px",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.RegionName,
        },
        {
            name: 'Status',
            sortable: true,
            float: 'left',
            minWidth: '100px',
            selector: (listData: any) => {
                const statusId = Number(listData?.StatusId || listData?.statusId || AgentStatus.Submit);
                const statusName = listData?.StatusName || listData?.Status || 'Submit';
                return (
                    <span
                        className={statusId === AgentStatus.Submit ? 'text-warning' : statusId === AgentStatus.Approved ? 'text-success' : 'text-danger'}
                        style={{ cursor: 'pointer', textDecoration: (statusId === AgentStatus.Approved || statusId === AgentStatus.Rejected) ? 'underline' : 'none' }}
                        onClick={() => {
                            if (statusId === AgentStatus.Approved || statusId === AgentStatus.Rejected) {
                                setModalConfig({
                                    show: true,
                                    actionType: 'View',
                                    viewData: {
                                        Remark: listData?.ApprovalRemark,
                                        RejectionReason: listData?.ReasonText
                                    },
                                    CorporateAgentId: listData?.CorporateId
                                });
                            }
                        }}
                    >
                        {statusName}
                    </span>
                );
            }
        },
        {
            name: 'Action',
            minWidth: '130px',
            omit: loginUserDomainMasterId !== 1,
            selector: (listData: any) => {
                const statusId = Number(listData?.StatusId || listData?.statusId || AgentStatus.Submit);
                const actionOptions = (agentData?.statusOptions || []).filter((opt: any) => !([AgentStatus.Pending, AgentStatus.Submit, AgentStatus.ReSubmit] as number[]).includes(Number(opt.StatusId)));

                if (statusId === AgentStatus.Submit) {
                    return (
                        <select
                            className="form-select form-select-sm"
                            onChange={(e) => {
                                const action = e.target.value;
                                if (action && action !== '') {
                                    setModalConfig({
                                        show: true,
                                        actionType: action as any,
                                        viewData: { Remark: '', RejectionReason: '' },
                                        CorporateAgentId: listData?.CorporateId
                                    });
                                }
                                e.target.value = ''; // Reset select after action
                            }}
                        >
                            <option value="">Select</option>
                            {actionOptions.map((opt: any, index: number) => (
                                <option key={index} value={opt?.StatusName === 'Approved' ? 'Approve' : opt?.StatusName === 'Rejected' ? 'Reject' : opt?.StatusName}>
                                    {opt?.StatusName}
                                </option>
                            ))}
                        </select>
                    );
                }
                return <span>-</span>;
            }
        },
        {
            name: 'Edit',
            selector: (listData: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!useredit}><i className="fa-regular fa-pen-to-square" onClick={() => handleEdit(listData, listData?.CorporateId)}></i></button>
        },
        {
            name: 'View',
            selector: (listData: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr'><i className="fa-regular fa-eye" onClick={() => handleView(listData, listData?.CorporateId)}></i></button>
        }
    ];

    useEffect(() => {
        //check for rights
        let pagelink: any = tbaData?.find((x: any) => {
            if (x.PageLink === window.location.pathname)
                return x?.MenuId
        });
        let mid = tbaData?.find((x: any) => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        tbaData?.filter((x: any) => x.MenuId === pagelink?.MenuId).map((obj: any) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);
        });

    }, [tbaData]);

    const handleOpen = () => {
        navigate('/corporate-management/add-corporate',
            {
                state:
                {
                    disabled: false,
                    editdisabled: true,
                    viewtype: 'Add',
                    id: 0, datalist: datalist
                }
            });
    }

    const handleEdit = (itemData: any, id: number) => {
        navigate('/corporate-management/add-corporate', {
            state: {
                disabled: false,
                editdisabled: true,
                viewtype: 'Update',
                id: id,
                itemData: itemData,
                datalist: datalist
            }
        });
    }

    const handleView = (itemData: any, id: number) => {
        navigate('/corporate-management/add-corporate', {
            state: {
                disabled: true,
                editdisabled: true,
                viewtype: 'View',
                id: id,
                itemData: itemData,
                datalist: datalist
            }
        });
    }

    useEffect(() => {
        getLoginUserDomianId();
        getlistdata();
        (dispatch as any)(agentActions.getAgentOptions());
    }, [])

    return (
        <Fragment>
            <div className="m-2 heading_color d-flex justify-content-between">
                <h4>Corporate List</h4>
                {
                    loginUserDomainMasterId === 1 &&
                    <button type="button" disabled={!useradd} className="btn btn-primary" id="btnAdd" onClick={handleOpen} >+ Add Corporate</button>
                }
            </div>
            <div className="m-2 mt-5">
                <form action="" className='mt-3'>
                    <div className="d-flex justify-content-start">
                    </div>
                    <CommonFilter
                        filtercolumns={columns}
                        filteritems={filterlist}
                        setFilterList={setDataList}
                        getdata={getlistdata}
                        // serchdisable={serchdisable}
                        setSearchValue={setSearchValue}
                        searchvalue={searchvalue}
                        setSerachBy={setSerachBy}
                        searchby={searchby}
                    />

                    <CustomTable
                        className={"last_two_column_freeze"}
                        columns={columns}
                        data={datalist}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={false}
                    />
                </form>
            </div >

            <StatusActionModal
                show={modalConfig.show}
                onHide={() => setModalConfig({ ...modalConfig, show: false })}
                actionType={modalConfig.actionType}
                viewData={modalConfig.viewData}
                CorporateAgentId={modalConfig.CorporateAgentId}
                onSuccess={() => {
                    getlistdata();
                }}
            />
        </Fragment>
    )
}

export default CorporateList